import TripsRegistryContainer from './TripsRegistryContainer';

export default TripsRegistryContainer;
